import GhostLoader from 'react-ghost-loader';
import React from 'react';
import { Button } from '@attain-sre/attain-design-system';
import {
  OTS_SGM_MNG_REMODELING_LAST_REMODELED,
  OTS_SGM_MNG_REMODELING_NEXT_REMODEL,
  OTS_SGM_MNG_REMODELING_SCHEDULE,
  OTS_SGM_MNG_REMODELING_UPDATE_SCHEDULE,
} from '../../../../content';
import * as Styled from './index.styles';

interface ScheduleInfoBarProps {
  schedule: string;
  lastExportedDate: string;
  nextExportDate: string;
  onUpdateScheduleClick: () => void;
  loading?: boolean;
}

const ScheduleInfoBar: React.FC<ScheduleInfoBarProps> = ({
  schedule,
  lastExportedDate,
  nextExportDate,
  onUpdateScheduleClick,
  loading = false,
}) => {
  return (
    <Styled.Container>
      <Styled.InfoSection>
        <Styled.InfoItem>
          <Styled.Label>{OTS_SGM_MNG_REMODELING_SCHEDULE}:</Styled.Label>
          <Styled.Value>
            {loading ? <GhostLoader height="20px" width="100px" /> : schedule}
          </Styled.Value>
        </Styled.InfoItem>
        <Styled.InfoItem>
          <Styled.Label>{OTS_SGM_MNG_REMODELING_LAST_REMODELED}:</Styled.Label>
          <Styled.Value>
            {loading ? (
              <GhostLoader height="20px" width="80px" />
            ) : (
              lastExportedDate
            )}
          </Styled.Value>
        </Styled.InfoItem>
        <Styled.InfoItem>
          <Styled.Label>{OTS_SGM_MNG_REMODELING_NEXT_REMODEL}:</Styled.Label>
          <Styled.Value>
            {loading ? (
              <GhostLoader height="20px" width="80px" />
            ) : (
              nextExportDate
            )}
          </Styled.Value>
        </Styled.InfoItem>
      </Styled.InfoSection>
      <Button
        variant="contained"
        size="small"
        onClick={onUpdateScheduleClick}
        disabled={loading}
        style={{
          height: 32,
        }}
      >
        {OTS_SGM_MNG_REMODELING_UPDATE_SCHEDULE}
      </Button>
    </Styled.Container>
  );
};

export default ScheduleInfoBar;
